import { render } from "./EmailTemplate.vue?vue&type=template&id=7579abef&scoped=true"
import script from "./EmailTemplate.vue?vue&type=script&lang=js"
export * from "./EmailTemplate.vue?vue&type=script&lang=js"

import "./EmailTemplate.vue?vue&type=style&index=0&id=7579abef&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7579abef"]])

export default __exports__